import axios from 'lib/axios'
import { FrameworkCategory, IFramework } from 'models'

const basePath = '/api/v3/frameworks'

export const FrameworkServiceV3 = {
  searchFrameworkCategories: async (params: Record<string, any>): Promise<FrameworkCategory[]> => {
    const { data } = await axios.get(`${basePath}/categories?fetch-categories`, { params })
    return data.data.categories
  },
  getCustomFramework: async (): Promise<IFramework> => {
    const { data } = await axios.get(`${basePath}/custom`)
    return data.framework
  }
}
